"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var certification_watermark_1 = require("@tableau/certification-watermark");
var SpacesCaptionCertified_1 = require("../../../gen-src/icons/SpacesCaptionCertified");
var Localize_1 = require("../../../gen-src/Localize");
var VizPortalStyles_1 = require("../../style/VizPortalStyles");
var TableauUser_1 = require("../TableauUser");
function CertificationIcon(props) {
    return props.icon || React.createElement(SpacesCaptionCertified_1.SvgSpacesCaptionCertified, { className: VizPortalStyles_1.certificationIconStyle });
}
function CertificationWidget(props) {
    var certifier = props.certification.certifier;
    if (!props.certification.isCertified || !certifier) {
        return null;
    }
    var url = TableauUser_1.tableauUserUrl(props.siteUrls, certifier);
    var displayName = TableauUser_1.tableauUserName(certifier, undefined);
    var note = props.certification.certificationNote || '';
    var icon = React.createElement(CertificationIcon, __assign({}, props));
    var tooltipProps = {
        id: props.contentId,
        icon: icon,
        note: note,
        certifier: {
            displayName: displayName,
            url: url
        },
        className: props.className,
        showExtractRefresh: props.showExtractRefresh
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(certification_watermark_1.CertificationTooltipComponent, __assign({}, tooltipProps)),
        props.renderUser ? React.createElement(TableauUser_1.TableauUser, { tableauUser: certifier, labelText: Localize_1.Messages.CertifiedBy, siteUrls: props.siteUrls }) : null));
}
exports.CertificationWidget = CertificationWidget;
//# sourceMappingURL=CertificationWidget.js.map